module.exports = __webpack_public_path__ + "img/totalizador-imoveis.049e78d7.svg";